export default __webpack_public_path__ + "static/media/eatingtimes_2.6e90bc3a.jpg";